import GA4React from 'ga-4-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useGAPageview = () => {
  const location = useLocation();
  const ga4react = new GA4React('G-0C3CWYT7QK', {
    send_page_view: false,
  });
  useEffect(() => {
    try {
      const pagepath = `${
        process.env.REACT_APP_HOST_TYPE === 'prod'
          ? ''
          : `[${process.env.REACT_APP_HOST_TYPE}]`
      }${location.pathname}`;
      ga4react?.pageview(pagepath);
    } catch (error) {
      console.log(error);
    }
  }, [location]);
};

export default useGAPageview;
